
export enum BlockMoveDirectionEnum {
    up,
    down,
    left,
    right
}
